import { render, staticRenderFns } from "./addMaterial.vue?vue&type=template&id=3a8a743f&scoped=true&"
import script from "./addMaterial.vue?vue&type=script&lang=js&"
export * from "./addMaterial.vue?vue&type=script&lang=js&"
import style0 from "./addMaterial.vue?vue&type=style&index=0&id=3a8a743f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8a743f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a8a743f')) {
      api.createRecord('3a8a743f', component.options)
    } else {
      api.reload('3a8a743f', component.options)
    }
    module.hot.accept("./addMaterial.vue?vue&type=template&id=3a8a743f&scoped=true&", function () {
      api.rerender('3a8a743f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/publicizeMaterialManagement/addMaterial.vue"
export default component.exports